import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class InvestmentsGalleryCards {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.galleryEl = this.root.querySelectorAll(
            '[data-investments-gallery-cards-gallery]'
        );

        console.log(this.galleryEl);

        return true;
    }

    init() {
        this.setGalleries();
    }

    setGalleries() {
        if (!this.galleryEl) return;

        this.galleryEl.forEach(item => {
            const swiperEl = item.querySelector(
                '[data-investments-gallery-cards-gallery-swiper]'
            );
            const prevEl = item.querySelector(
                '[data-investments-gallery-cards-gallery-prev]'
            );
            const nextEl = item.querySelector(
                '[data-investments-gallery-cards-gallery-next]'
            );

            console.log(swiperEl);

            this.setSwiper(swiperEl, prevEl, nextEl);
        });
    }

    setSwiper(swiperEl, prevEl, nextEl) {
        if (!swiperEl) return;

        const swiper = new Swiper(swiperEl, {
            modules: [Navigation],
            speed: 650,
            slidesPerView: 1,
            navigation: {
                prevEl,
                nextEl,
            },
        });
    }
}

const sections = document.querySelectorAll('[data-investments-gallery-cards]');
const setInvestmentsGalleryCards = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new InvestmentsGalleryCards(el);
    });
};

setInvestmentsGalleryCards(sections);
